import React, { useState } from "react";
import { FaRegTrashCan } from "react-icons/fa6";
import { FaRegEdit, FaShare } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import SharePopup from "../../../../PopUp/SocialSharePopup/SharePopup";

const ProductCard = ({
	product,
	onBuy,
	onAccess,
	loggedInUserId,
	isAdmin,
	onDelete,
	onUpdate,
	communityId,
}) => {
	const [sharePopupOpen, setSharePopupOpen] = useState(false);
	const [socialUrl, setSocialUrl] = useState("");
	const navigate = useNavigate();
	const isPurchased = product.purchased_by?.includes(loggedInUserId);

	const handleOpenSocialShare = (e) => {
		e.stopPropagation();
		const baseUrl = window.location.origin;
		const productUrl = `${baseUrl}/community/${communityId}/product/${product._id}`;
		setSocialUrl(productUrl);
		setSharePopupOpen(true);
	};

	const handleCardClick = () => {
		navigate(`/community/${communityId}/product/${product._id}`);
	};

	return (
		<>
			<div className="product-card" onClick={handleCardClick}>
				<div className="product-image">
					<img src={product.image} alt={product.name} />
					<span className={`badge ${product.is_free ? "free" : "paid"}`}>
						{product.is_free ? "Free" : `₹${product.amount}`}
					</span>
				</div>
				<div className="product-content">
					<h3 className="line-clamp-1">{product.name}</h3>
					<p 
						className="description line-clamp-3"
					>
					<div dangerouslySetInnerHTML={{__html: product.description}} />
					</p>
					<button
						className="access-btn"
						onClick={(e) => {
							e.stopPropagation();
							isAdmin || isPurchased ? onAccess(product) : onBuy(product);
						}}
					>
						{isAdmin
							? "Access Resource"
							: isPurchased
							? "Access Resource"
							: product.is_free
							? "Buy for Free"
							: `Buy ₹${product.amount}`}
					</button>
				</div>

				{isAdmin && (
					<>
						<div 
							className="updateProduct" 
							onClick={(e) => {
								e.stopPropagation();
								onUpdate();
							}}
						>
							<FaRegEdit size={25} />
						</div>
						<div 
							className="delete-product" 
							onClick={(e) => {
								e.stopPropagation();
								if (window.confirm('Are you sure you want to delete this product?')) {
									onDelete();
								}
							}}
						>
							<FaRegTrashCan size={25} />
						</div>
					</>
				)}
				<div className="share-product" onClick={handleOpenSocialShare}>
					<FaShare size={25} />
				</div>
			</div>

			{sharePopupOpen && (
				<SharePopup
					postId={product._id}
					isOpen={sharePopupOpen}
					setIsOpen={setSharePopupOpen}
					url={socialUrl}
				/>
			)}
		</>
	);
};

export default ProductCard;
